export const colors = {
  primary: '#1D6973',
  primary2: '#14585C',
  red: '#E3082F',
}
